import classNames from 'classnames';
import { memo } from 'react';

import { CheckIcon } from '@air/design-icons';
import { Chip } from '@air/primitive-chip';
import { DropdownMenuItem } from '@air/primitive-dropdown-menu';

export type AssetVersionShareLinkMenuItemProps = {
  chipLabel: string;
  isEnabled: boolean;
  isSelected: boolean;
  onSelect: () => void;
  optionKey: string;
  title: string;
  titleClassName?: string;
};

export const AssetVersionShareLinkMenuItem = memo(
  ({
    chipLabel,
    isEnabled,
    isSelected,
    onSelect,
    optionKey,
    title,
    titleClassName,
  }: AssetVersionShareLinkMenuItemProps) => (
    <DropdownMenuItem
      className="gap-2 p-1"
      // biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration
      data-testid={`ASSET_VERSION_SHARE_LINK_OPTION_${optionKey}`}
      onSelect={onSelect}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <span className={classNames('min-w-0 truncate ads:text-primary text-14 text-gray-12', titleClassName)}>
          {title}
        </span>
        <Chip appearance="filled" className="shrink-0" color="gray" size="small">
          {chipLabel}
        </Chip>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {isEnabled ? (
          <Chip appearance="filled" className="shrink-0" color="light-green" size="small">
            Enabled
          </Chip>
        ) : null}
        {isSelected ? (
          <CheckIcon aria-hidden className="shrink-0 ads:text-icon-primary text-blue-9" size="sm" />
        ) : (
          <span aria-hidden className="size-4 shrink-0" />
        )}
      </div>
    </DropdownMenuItem>
  ),
);

AssetVersionShareLinkMenuItem.displayName = 'AssetVersionShareLinkMenuItem';
